import React, { useState } from 'react';
import { useEstimatedArrival } from '../../../context/estimatedArrival/EstimatedArrivalContextProvider';
import FileUploadTemplate from '../../../components/common/FileUpload/FileUploadTemplate';

const Upload = () => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const { uploadETAFileAPI } = useEstimatedArrival();

  const handleFilesSelected = (files) => {
    if (files.length !== 1) {
      alert('Please upload exactly one file.');
      return;
    }
    setSelectedFiles(files);
  };

  const handleUpload = async (files) => {
    if (files.length === 1) {
      await uploadETAFileAPI(files[0]);
      setSelectedFiles([]); // Clear selected files after successful upload
    } else {
      alert('Please select a file to upload.');
    }
  };

  return (
    <div className="flex justify-center">
      <div>
        <h2 className="text-2xl font-semibold text-gray-800 mb-4"></h2>
        <p className="text-gray-500 mb-6 text-center">
          Please upload an XML file containing product data.
        </p>

        <FileUploadTemplate
          acceptedFileTypes={['.xml']}
          onFilesSelected={handleFilesSelected}
          multiple={false}
          onUpload={handleUpload}
          maxFiles={1}
        />
      </div>
    </div>
  );
};

export default Upload;
